import type { CouponTranslationEntity } from './CouponTranslationEntity'
import type { CouponOnItemDeliveryEntity } from './CouponOnItemDeliveryEntity'

export class CouponEntity {
  id?: number
  redeemCode?: string | null
  validFrom?: string
  validTo?: string
  maxUsageCount?: number
  maxUsagePerUser?: number
  minCartAmount?: number
  isActive?: boolean
  hidden?: boolean
  translations?: CouponTranslationEntity[]
  onItem?: CouponOnItemDeliveryEntity
  onDelivery?: CouponOnItemDeliveryEntity
  canBeAppliedWithCampaign?: boolean
  imageUrl?: string | null
}
